<template>
    <el-row>
        <el-col>
            <el-table :data="checkData" style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }">
                <el-table-column type="index" label="序号">
                </el-table-column>
                <el-table-column prop="checkCompany" label="检定/校准单位" sortable width="300">
                </el-table-column>
                <el-table-column prop="checkCertificate" label="检定/校准证书号" sortable width="230">
                </el-table-column>
                <el-table-column prop="checkTime" label="检定/校准日期" sortable width="150">
                </el-table-column>
                <el-table-column prop="jdlx" label="类型" sortable width="130">
                    <template slot-scope="scope">
                        <span v-if="scope.row.jdlx == 0">检定</span>
                        <span v-if="scope.row.jdlx == 1">校准</span>
                        <span v-if="scope.row.jdlx == 2">外部校准</span>
                    </template>
                </el-table-column>
                <el-table-column prop="wz" label="状态" sortable width="100">
                </el-table-column>
                <el-table-column label="操作" width="280">
                    <template slot-scope="scope">
                        <el-link :underline="false" style="color: #4095E5;text-decoration: none;"
                            @click="toCheckDetail(scope.row)">详情</el-link>
                        <el-button type="text" size="small" style="color: red; margin-left: 10px"
                            v-if="userRoles.indexOf('220') != -1" @click="simpleDeleteCheck(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-col>

        <!--分页工具条-->
        <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
            <el-pagination v-if="checkData.length > 0" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :page-sizes="[5]" :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
            </el-pagination>
        </el-col>
    </el-row>
</template>
<script>
import { getByDeviceId, deleteCheckId, simpleDeleteCheckId } from '../../../api/api';
export default {
    data() {
        return {
            pagesize: 5,
            pageIndex: 1,
            total: 4,
            checkData: [],
            userRoles: ''
        }
    },
    props: {
        deviceinfo: {
            default: {}
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.pageIndex = val;
            //     //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
            //     //.slice()方法接受两个参数，开始和结束的值
            //     //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
            this.getDeviceByDeviceId();
        },
        handleSizeChange(val) {
            this.pagesize = val;
            this.getDeviceByDeviceId();
        },
        getDeviceByDeviceId() {
            let id = JSON.parse(sessionStorage.getItem("deviceinfoDetail")).id;
            let _params = {
                deviceId: id,
                pageIndex: this.pageIndex,
                pageSize: this.pagesize
            }
            getByDeviceId(_params).then(datas => {
                let { status, data, message } = datas
                if (status == 200) {
                    this.checkData = data.list
                    this.total = data.total
                }
            })
        },
        simpleDeleteCheck(row) {
            this.$confirm('仅删除该条检定记录，不会回退设备的检定日期和状态。确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                simpleDeleteCheckId(row.id).then((datas) => {
                    let { status, message } = datas;
                    if (status == 200) {
                        this.$message({ message: '删除成功', type: 'success' });
                        this.getDeviceByDeviceId();
                    } else {
                        this.$message({ message: message || '删除失败', type: 'error' });
                    }
                });
            }).catch(() => { });
        },
        deleteCheck(row) {
            this.$confirm('删除该条检定记录，同时回退设备的检定日期和状态。确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteCheckId({ id: row.id }).then((datas) => {
                    let { status, message } = datas;
                    if (status == 200) {
                        this.$message({ message: '删除成功', type: 'success' });
                        this.getDeviceByDeviceId();
                    } else {
                        this.$message({ message: message || '删除失败', type: 'error' });
                    }
                });
            }).catch(() => { });
        },
        toCheckDetail(row) {
            let jdlx = row.jdlx
            sessionStorage.setItem("id", row.id)
            if (jdlx == 0) {//检定
                if (this.userRoles.indexOf("151") == -1) {
                    this.$message({ message: "你没有权限访问该页面", type: 'warning' });
                } else {
                    this.$router.push({
                        path: "particulars"
                    });
                }
            }
            if (jdlx == 1) {//内部校准
                if (this.userRoles.indexOf("180") == -1) {
                    this.$message({ message: "你没有权限访问该页面", type: 'warning' });
                } else {
                    this.$router.push({
                        path: "correctingParticulars"
                    });
                }
            }
            if (jdlx == 2) {//外部校准
                if (this.userRoles.indexOf("177") == -1) {
                    this.$message({ message: "你没有权限访问该页面", type: 'warning' });
                } else {
                    this.$router.push({
                        path: "calibrationParticulars"
                    });
                }
            }
        }
    },

    created() {
        let userinfo = JSON.parse(localStorage.getItem("user"));
        this.userRoles = userinfo.role.menuId || '';
        this.getDeviceByDeviceId();
    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/views/device/components/DeviceCheckRecord.vue